<div  style="padding: 15px;">
  <div class="row" style="margin-top: 30px;">
    <div class="col-lg-4">
      <label style="font-weight: bold;margin-bottom: 5px;">{{ language == 'en'? 'Name' : 'الاسم' }}</label>
      <input class="form-control" (keyup)="UpdateText()" [(ngModel)]="Name"
        [placeholder]="language == 'en'? 'Write your name' : 'اكتب اسمك'">
    </div>
    <div class="col-lg-4">
      <label style="font-weight: bold;margin-bottom: 5px;">{{ language == 'en'? 'Font color' : 'لون الخط' }}</label>

      <select [(ngModel)]="selectedColor" (change)="UpdateText()" class="form-control">
        <option value="Black">{{ language == 'en'? 'Select color' : 'اختر اللون' }}</option>
        <option *ngFor="let color of colors" [value]="color" [style.background-color]="color">{{color}}</option>
        <option value="">{{ language == 'en'? 'Another color' : 'لون اخر' }}</option>
      </select>
    </div>
    <div class="col-lg-3" *ngIf="AnotherColor">
      <label style="font-weight: bold;margin-bottom: 5px;">{{ language == 'en'? 'Another font color' : 'لون خط اخر' }}</label>

      <input class="form-control" (keyup)="UpdateText()" [(ngModel)]="AnotherColortxt"
        [placeholder]="language == 'en'? 'Write your color' : 'اكتب اللون'">
    </div>
  </div>
  <div class="row text-center" style="margin: 30px 0px;">
    <div class="col-lg-6 text-center">
      <canvas #myCanvas id="canvas" width="700px" height="500px" style="right: 0px !important;"></canvas>
    </div>
  </div>
  <div class="text-center">
    <button class="btn btn-success" (click)="SaveImage()" style="margin: 10px;">{{ language == 'en'? 'Save Image' : 'حفظ
      الصورة'}}</button>
    <button class="btn btn-danger" (click)="onNoClick()">{{ 'COMMON.BACK' | translate }}</button>

  </div>
</div>